import * as React from "react";
import * as S from "@styled";
import ReactMarkdown from "react-markdown";
import remarkGfm from 'remark-gfm'
import { connect } from "react-redux";

import { State } from "../model/State";

import { DispatchType } from "../../shared/utilities";
import { updateElementDescription } from "../actions/UpdateElementDescription";

export const DescriptionEditor: React.FC<DescriptionEditorProps> = (props) => {
    const handleChange = (event: any) => props.onChange && props.onChange(event.target.value);

    return props.showAsReadonly
        ? <ReactMarkdown
            className="description"
            remarkPlugins={[remarkGfm]}
            components={{
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                a: ({ node, ...props }) => <a target="_blank" rel="noopener noreferrer" {...props} />
            }}
        >
            {props.description ?? ""}
        </ReactMarkdown>
        : <S.FormGroup id={props.id + "-description"}>
            <S.Label>
                {FRENDS.Localizations.Description}
            </S.Label>
            <S.TextArea rows={3} value={props.description || ""} onChange={handleChange} disabled={props.disabled} />
        </S.FormGroup>;
};

interface DescriptionEditorProps {
    id: string | undefined;
    description?: string;
    defaultDescription?: string;
    showAsReadonly?: boolean;
    disabled?: boolean;
    onChange?: (value: string) => void;
}

const mapStateToProps = (state: State, ownProps: DescriptionEditorProps): DescriptionEditorProps => {
    const hasExisting = state.elements[ownProps.id as string].description != null;
    const existing = hasExisting ? state.elements[ownProps.id as string].description : ownProps.defaultDescription;
    return {
        id: ownProps.id,
        description: existing,
        disabled: state.uiState.disableEdit || state.uiState.isSaving
    };
};

const mapDispatchToProps = (dispatch: DispatchType<State>, ownProps: DescriptionEditorProps): DescriptionEditorProps => {
    return {
        id: ownProps.id,
        onChange: (value) => dispatch(updateElementDescription(ownProps.id, value))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DescriptionEditor);
